import { Card, Row, Col, Typography, Divider, Button, Space, Collapse, Spin, message } from "antd";
import { ScheduleOutlined, TagsOutlined, CopyOutlined, TableOutlined, WalletOutlined, EditOutlined, EyeOutlined, DownloadOutlined, DeleteOutlined, ArrowRightOutlined, RightOutlined, DownOutlined, UserOutlined } from "@ant-design/icons";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import "../../assets/dist/NewApplication/ApplicantPreview.css";
import { useEffect, useState } from "react";
import { DollarOutlined } from "@ant-design/icons";
import _NewapplicationService from "../../modules/NewapplicationService";
import _ApplicantBankerAdjustmentService from "../../modules/ApplicantBankerAdjustmentService";
import { useHistory } from "react-router-dom";
import { routes } from "../../routes/Routes";
import moment from "moment";
import _commonService from "../../modules/commonService";
import { ScreenNameDashboard } from "../../constants/DataConstants";
import { AdjustmentScreenModule, AdjustmentTableName } from "../../constants/adjustmentConstants";
import { canViewAdjustments, canAdjust } from "../../utils/adjustmentPermissions";
import CommentSection from "./CommentSection";
import AdjustmentField from "../../components/AdjustmentField/AdjustmentField";
import BalanceSheetQuestionnaireDashboard from "./BalanceSheetQuestionnaireDashboard";
import "./ApplicationDetailsTab.scss"

const { Title, Text } = Typography;
const FinancialStatementTab = ({ activeKey, applicantDetails, ApplicationObjId, onLoanAmountAdjusted }) => {
  const [applicationstatusid] = useState(applicantDetails.Application_Status_Id)
  const [incomeSourceDetails, setIncomeSourceDetails] = useState({});
  const [expensesDetails, setExpensesDetails] = useState({});
  const [cashShortTermInvestmentDetails, setCashShortTermInvestmentDetails] = useState([]);
  const [dataLoadedCashShortTerm, setDataLoadedCashShortTerm] = useState(false);
  const [dataLoadedStockAndBond, setDataLoadedStockAndBond] = useState(false);
  const [dataLoadedCashValue, setDataLoadedCashValue] = useState(false);
  const [dataLoadedunListedStocks, setDataLoadedunListedStocks] = useState(false);
  const [dataLoadedVestedIntrestPension, setDataLoadedVestedIntrestPension] = useState(false);
  const [dataLoadedAccountNotesReceivable, setDataLoadedAccountNotesReceivable] = useState(false);
  const [dataLoadedownPersonalResidence, setDataLoadedownPersonalResidence] = useState(false);
  const [dataLoadedLimitedPartenership, setDataLoadedLimitedPartenership] = useState(false);
  const [dataLoadedreInvestment, setDataLoadedreInvestment] = useState(false);
  const [dataLoadednotesPayableBankSecured, setDataLoadednotesPayableBankSecured] = useState(false);
  const [dataLoadednotesPayableBankUnSecured, setDataLoadednotesPayableBankUnSecured] = useState(false);
  const [dataLoadednotesPayableOther, setDataLoadednotesPayableOther] = useState(false);
  const [dataLoadedAccountPayable, setDataLoadedAccountPayable] = useState(false);
  const [dataLoadedcreditCardBalance, setDataLoadedcreditCardBalance] = useState(false);
  const [dataLoadedMortgagesDueBeyond, setDataLoadedMortgagesDueBeyond] = useState(false);
  const [dataLoadedMortgagesDueWithInOne, setDataLoadedMortgagesDueWithInOne] = useState(false);
  const [listedStockAndBondsDetails, setListedStockAndBondsDetails] = useState([]);
  const [accountsandNotesReceivableDetails, setccountsandNotesReceivableDetails] = useState([]);
  const [cashValueLifeInsuranceDetails, setCashValueLifeInsurance] = useState([]);
  const [financialStatementDataDetails, setfinancialStatementData] = useState([]);
  const [ownPersonalResidenceDetails, setOwnPersonalResidenceDetails] = useState([]);
  const [vestedIntrestPensionDetails, setVestedIntrestPensionDetails] = useState([]);
  const [unListedStocksDetails, setunListedStocksDetails] = useState([]);
  const [reInvestmentDetails, setreInvestmentDetails] = useState([]);
  const [generalAndLimitedPartenershipDetails, setGeneralAndLimitedPartenershipDetails] = useState([]);
  const [notesPayableBankSecuredDetails, setNotesPayableBankSecuredDetails] = useState([]);
  const [notesPayableBankUnSecuredDetails, setNotesPayableBankUnSecuredDetails] = useState([]);
  const [accountPayableDetails, setAccountPayableDetails] = useState([]);
  const [notesPayableOtherDetails, setNotesPayableOtherDetails] = useState([]);
  const [creditCardBalanceDetails, setCreditCardBalanceDetails] = useState([]);
  const [mortgagesDueWithInOneDetails, setMortgagesDueWithInOneDetails] = useState([]);
  const [mortgagesDueBeyondOneDetails, setMortgagesDueBeyondOneDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  // Banker/Underwriter Adjustment feature (BankerAdjustmentExecutionPlan.md Section 8.3): the
  // current (latest) adjustment overlay for this application, fetched once and looked up per
  // field via findAdjustment(). Only ever populated for Senior Private Banker/Underwriter Banker
  // -- every other role's render path below is completely unchanged.
  const [adjustments, setAdjustments] = useState([]);

  const history = useHistory();
  const canSeeAdjustments = canViewAdjustments();
  // An application-wide lock (set at Approval) shows up on every one of its adjustment rows; if
  // no adjustment has ever been made yet there's nothing to read it off of, but in that case the
  // role+status check below already blocks editing once the status has moved past 7/8 anyway --
  // the real enforcement is server-side in SaveAdjustment regardless of this flag.
  const isAdjustmentsLocked = adjustments.some((a) => a.IsLocked);
  const canEditAdjustments = canSeeAdjustments && canAdjust(applicationstatusid, isAdjustmentsLocked);

  useEffect(() => {
    if (activeKey && activeKey == "3") {
      getIncomeSourceDetailsByID();
      getExpensesDetailsByID();
      getFinancialStatementData();
      if (canSeeAdjustments) {
        getAdjustments();
      }
    }
  }, [activeKey]);

  const getAdjustments = async () => {
    try {
      const res = await _ApplicantBankerAdjustmentService.getAdjustmentsByApplicationId(ApplicationObjId);
      if (res.data && res.data.IsSuccess) {
        setAdjustments(res.data.Obj || []);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const findAdjustment = (tableName, fieldName, sourceRowId = null) =>
    adjustments.find(
      (a) => a.TableName === tableName && a.FieldName === fieldName && (a.SourceRowId ?? null) === sourceRowId
    );

  const handleSaveAdjustment = async (screenModule, tableName, fieldName, sourceRowId, adjustedValue, reason) => {
    const res = await _ApplicantBankerAdjustmentService.saveAdjustment({
      applicationId: ApplicationObjId,
      screenModule,
      tableName,
      fieldName,
      sourceRowId,
      adjustedValue,
      reason,
    });
    if (res.data && res.data.IsSuccess) {
      message.success(res.data.Message || "Adjustment saved successfully.");
      await getAdjustments();
      // The "Loan Enquiry Amount" header (LoanDetailsHeader) reads App_Det_LoanAmount_BankerAdjusted
      // from the parent's applicantDetails, which this tab never updates on its own -- refresh it
      // immediately after a Loan Amount adjustment so it reflects without navigating away and back.
      if (fieldName === "App_Det_LoanAmount" && typeof onLoanAmountAdjusted === "function") {
        await onLoanAmountAdjusted();
      }
    } else {
      message.error((res.data && res.data.Message) || "Something went wrong.");
      throw new Error((res.data && res.data.Message) || "Save failed");
    }
  };

  // Backs every AdjustmentField's "View/History" (eye) icon -- reuses the existing
  // ApplicantBankerAdjustment/GetAdjustmentHistory endpoint (already returns latest-first) rather
  // than adding a new one, since it already returns exactly this shape.
  const handleViewHistory = async (tableName, fieldName, sourceRowId) => {
    const res = await _ApplicantBankerAdjustmentService.getAdjustmentHistory({
      applicationId: ApplicationObjId,
      tableName,
      fieldName,
      sourceRowId: sourceRowId ?? null,
    });
    if (res.data && res.data.IsSuccess) {
      return res.data.Obj || [];
    }
    message.error((res.data && res.data.Message) || "Failed to load adjustment history.");
    return [];
  };

  // The handful of Balance Sheet category totals that have no per-row breakdown on this screen
  // (Other Liquid Assets, IRA/Keogh, Equity Interest in Business, Personal Property, Other
  // Assets, Unpaid Income Taxes, Margin Accounts, Other Liabilities) -- single fields directly on
  // Applicant ("Pattern A"), rendered in the same left-label/right-value row layout the static
  // totals already use. Passing label="" to AdjustmentField suppresses its own label line since
  // the bold heading on the left already provides it.
  const renderStaticAdjustmentRow = (label, value, fieldName, screenModule) => (
    <div className="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
      <div className="ant-col">
        <span className="ant-typography"><strong>{label}</strong></span>
      </div>
      <div className="ant-col">
        {canSeeAdjustments ? (
          <AdjustmentField
            label=""
            asSubmittedValue={value}
            adjustment={findAdjustment(AdjustmentTableName.Applicant, fieldName)}
            canEdit={canEditAdjustments}
            onSave={(adjustedValue, reason) =>
              handleSaveAdjustment(screenModule, AdjustmentTableName.Applicant, fieldName, null, adjustedValue, reason)
            }
            onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, fieldName, null)}
          />
        ) : (
          <span className="ant-typography"><strong>{value ? `$ ${_commonService.formatNumberWithCommas(value)}` : "N/A"}</strong></span>
        )}
      </div>
    </div>
  );

  const getIncomeSourceDetailsByID = async () => {
    try {
      setLoading(true);
      const res = await _NewapplicationService.getIncomeSourceByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setIncomeSourceDetails(resObj[0]);
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };
  const getExpensesDetailsByID = async () => {
    try {
      setLoading(true);
      const res = await _NewapplicationService.getExpensesByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setExpensesDetails(resObj[0]);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };
  const getCashShortTermInvestmentDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getCashShortTermInvestmentsByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setCashShortTermInvestmentDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getListedStockAndBondsDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getStockBondGovSecurityByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setListedStockAndBondsDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getFinancialStatementData = async () => {
    try {
      setLoading(true);
      const res = await _NewapplicationService.getFinancialStatementData(ApplicationObjId, ScreenNameDashboard);
      if (res.data) {
        let resObj = res?.data.Obj;
        setfinancialStatementData(resObj);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.error("Error fetching assets", err);
    }
  };

  const getAccountsAndNotesReceivableDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getAccountNoteReceivableByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setccountsandNotesReceivableDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getCashValueLifeInsuranceDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getCashValueLifeInsuranceByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setCashValueLifeInsurance(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getOwnPersonalResidenceDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getOwnPersonalResidenceByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setOwnPersonalResidenceDetails(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getVestedIntrestPensionDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getVestedIntrestPensionByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setVestedIntrestPensionDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getUnListedStocksDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getUnListedStocksByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setunListedStocksDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getReInvestmentDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getInvestmentByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setreInvestmentDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getGeneralAndLimitedPartenershipDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getGeneralAndLimitedPartenershipByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setGeneralAndLimitedPartenershipDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getNotesPayableBankSecuredDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getNotesPayableBankSecuredByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setNotesPayableBankSecuredDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getNotesPayableBankUnSecuredDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getNotesPayableBankUnSecuredByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setNotesPayableBankUnSecuredDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getAccountsPayableDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getAccountsPayableByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setAccountPayableDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };

  const getNotesPayableOtherDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getNotesPayableOtherByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setNotesPayableOtherDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getCreditCardBalanceDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getCreditCardBalanceByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setCreditCardBalanceDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getMortagagesDueWithInOneDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getMortgageDueWithinByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setMortgagesDueWithInOneDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getMortagagesDueBeyondOneDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getMortgageDueBeyondByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setMortgagesDueBeyondOneDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };

  // const onIncomeSourcesEditClick = () => {
  //   history.push({
  //     pathname: routes.incomeSources.path,
  //     state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
  //   });
  // }
  // const onExpensesEditClick = () => {
  //   history.push({
  //     pathname: routes.expenses.path,
  //     state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
  //   });
  // }
  // const onBalanceSheetAssetsEditClick = () => {
  //   history.push({
  //     pathname: routes.balanceSheetAssets.path,
  //     state: { applicationObjId: ApplicationObjId, isFromDashboard: true, activeKey },
  //   });
  // }
  const handleCollapseCashShortTermInvestmentChange = (key) => {
    if (key === "1" && !dataLoadedCashShortTerm) {
      getCashShortTermInvestmentDetailsByID();
      setDataLoadedCashShortTerm(true);
    }
  }
  const handleCollapseListedStockAndBondChange = (key) => {
    if (key === "2" && !dataLoadedStockAndBond) {
      getListedStockAndBondsDetailsByID();
      setDataLoadedStockAndBond(true);
    }
  }
  const handleCollapseChangeAccountNotesReceivable = (key) => {
    if (key === "3" && !dataLoadedAccountNotesReceivable) {
      getAccountsAndNotesReceivableDetailsByID();
      setDataLoadedAccountNotesReceivable(true);
    }
  }
  const handleCollapseCashValueLifeInsurance = (key) => {
    if (key === "4" && !dataLoadedCashValue) {
      getCashValueLifeInsuranceDetailsByID();
      setDataLoadedCashValue(true);
    }
  }
  // const onBalanceSheetTotalAssetsEditClick = () => {
  //   history.push({
  //     pathname: routes.balanceSheetTotalAssets.path,
  //     state: { applicationObjId: ApplicationObjId, isFromDashboard: true, activeKey },
  //   });
  // }
  const handleCollapseOwnPersonalResidence = (key) => {
    if (key === "5" && !dataLoadedownPersonalResidence) {
      getOwnPersonalResidenceDetailsByID();
      setDataLoadedownPersonalResidence(true);
    }
  }
  const handleCollapseestedIntrestPension = (key) => {
    if (key === "6" && !dataLoadedVestedIntrestPension) {
      getVestedIntrestPensionDetailsByID();
      setDataLoadedVestedIntrestPension(true);
    }
  }
  const handleCollapUnListedStocks = (key) => {
    if (key === "7" && !dataLoadedunListedStocks) {
      getUnListedStocksDetailsByID();
      setDataLoadedunListedStocks(true);
    }
  }
  const handleCollapReInvestment = (key) => {
    if (key === "8" && !dataLoadedreInvestment) {
      getReInvestmentDetailsByID();
      setDataLoadedreInvestment(true);
    }
  }
  const handleCollapgeneralAndLimitedPartenership = (key) => {
    if (key === "9" && !dataLoadedLimitedPartenership) {
      getGeneralAndLimitedPartenershipDetailsByID();
      setDataLoadedLimitedPartenership(true);
    }
  }
  const handleCollapseNotesPayableBankSecured = (key) => {
    if (key === "10" && !dataLoadednotesPayableBankSecured) {
      getNotesPayableBankSecuredDetailsByID();
      setDataLoadednotesPayableBankSecured(true);
    }
  }
  const handleCollapseNotesPayableBankUnSecured = (key) => {
    if (key === "11" && !dataLoadednotesPayableBankUnSecured) {
      getNotesPayableBankUnSecuredDetailsByID();
      setDataLoadednotesPayableBankUnSecured(true);
    }
  }
  const handleCollapseAccountsPayableChange = (key) => {
    if (key === "12" && !dataLoadedAccountPayable) {
      getAccountsPayableDetailsByID();
      setDataLoadedAccountPayable(true);
    }
  }
  const handleCollapseChangeNotesPayableOther = (key) => {
    if (key === "13" && !dataLoadednotesPayableOther) {
      getNotesPayableOtherDetailsByID();
      setDataLoadednotesPayableOther(true);
    }
  }

  const handleCollapseChangeCreditCardsBalance = (key) => {
    if (key === "14" && !dataLoadedcreditCardBalance) {
      getCreditCardBalanceDetailsByID();
      setDataLoadedcreditCardBalance(true);
    }
  }
  const handleCollapseChangeMortagagesDueWihtinOne = (key) => {
    if (key === "15" && !dataLoadedMortgagesDueWithInOne) {
      getMortagagesDueWithInOneDetailsByID();
      setDataLoadedMortgagesDueWithInOne(true);
    }
  }
  const handleCollapseChangeMortagagesDueBeyondOne = (key) => {
    if (key === "16" && !dataLoadedMortgagesDueBeyond) {
      getMortagagesDueBeyondOneDetailsByID();
      setDataLoadedMortgagesDueBeyond(true);
    }
  }
  // const onBalanceSheetTotalLiabilitiesAssetsEditClick = () => {
  //   history.push({
  //     pathname: routes.balanceSheetTotalLiabilities.path,
  //     state: { applicationObjId: ApplicationObjId, isFromDashboard: true, activeKey },
  //   });
  // }
  return (
    <Spin spinning={loading}>
      <div className="financial-statement-tab">
        {canSeeAdjustments && (
          <Card
            title={
              <Row justify="space-between" align="middle">
                <Text strong>
                  <span role="img" aria-label="user" style={{ marginRight: 8 }}><DollarOutlined /> </span>
                  Loan Amount
                </Text>
              </Row>
            }
            className="card-section custom mb30"
          >
            <Row gutter={[16, 16]}>
              <Col span={8}>
                <AdjustmentField
                  label="Requested Loan Amount"
                  asSubmittedValue={applicantDetails?.App_Det_LoanAmount}
                  adjustment={findAdjustment(AdjustmentTableName.Applicant, "App_Det_LoanAmount")}
                  canEdit={canEditAdjustments}
                  onSave={(value, reason) =>
                    handleSaveAdjustment(AdjustmentScreenModule.Applicant, AdjustmentTableName.Applicant, "App_Det_LoanAmount", null, value, reason)
                  }
                  onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "App_Det_LoanAmount", null)}
                />
              </Col>
            </Row>
          </Card>
        )}
        <Card
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}><CopyOutlined /> </span>
                Income Sources
              </Text>
              {/* <EditOutlined onClick={onIncomeSourcesEditClick} style={{ color: "#595959", cursor: "pointer" }} /> */}
            </Row>
          }
          className="card-section custom mb30"
        >
          <div className="">
            <Row gutter={[16, 16]}>
              {[
                { label: "Salary (Gross)", field: "GrossSalary" },
                { label: "Bonus and Commissions", field: "BonusCommission" },
                { label: "Dividends", field: "Devidend" },
                { label: "Interest", field: "Interest" },
                { label: "Rental Income (Net)", field: "RentalIncome" },
                { label: "General Limited Partnership Income (Net)", field: "GenLimitedPartnershipIncome" },
                { label: "Trust Income", field: "TrustIncome" },
                { label: "Pension Income", field: "PensionIncome" },
                { label: "Other Income", field: "OtherIncome" },
              ].map(({ label, field }) => (
                <Col span={8} key={field}>
                  {canSeeAdjustments ? (
                    <AdjustmentField
                      label={label}
                      asSubmittedValue={incomeSourceDetails && incomeSourceDetails[field]}
                      adjustment={findAdjustment(AdjustmentTableName.ApplicantIncomesource, field)}
                      canEdit={canEditAdjustments}
                      onSave={(value, reason) =>
                        handleSaveAdjustment(AdjustmentScreenModule.IncomeSource, AdjustmentTableName.ApplicantIncomesource, field, null, value, reason)
                      }
                      onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantIncomesource, field, null)}
                    />
                  ) : (
                    <>
                      <Text type="secondary">{label}</Text>
                      <div className="b-bottm">{incomeSourceDetails && incomeSourceDetails[field] ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails[field])}` : "N/A"}</div>
                    </>
                  )}
                </Col>
              ))}
              <Col span={8}>
                {canSeeAdjustments ? (
                  // Read-only: no onSave/onViewHistory passed, so no edit (pencil) or history (eye)
                  // icon is rendered -- per today's note, Total isn't directly adjustable or
                  // history-browsable yet. The "Adjusted: $X / Last adjusted by..." block below
                  // still shows automatically whenever RecalculateIncomeSourceTotal has recorded
                  // one, since that part of AdjustmentField only depends on `adjustment` being set.
                  <AdjustmentField
                    label="Total"
                    asSubmittedValue={incomeSourceDetails && incomeSourceDetails.IncomeSourceTotal}
                    adjustment={findAdjustment(AdjustmentTableName.ApplicantIncomesource, "IncomeSourceTotal")}
                    canEdit={false}
                  />
                ) : (
                  <>
                    <Text type="secondary">Total</Text>
                    <div className="b-bottm">{incomeSourceDetails && incomeSourceDetails.IncomeSourceTotal ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.IncomeSourceTotal)}` : "N/A"}</div>
                  </>
                )}
              </Col>
            </Row>
            <CommentSection CommentSectionName="incomesource" applicationstatusid={applicationstatusid} applicantDetails={applicantDetails} ApplicationObjId={ApplicationObjId} />
          </div>

        </Card>

        <Card
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}><TableOutlined /> </span>
                Expenses
              </Text>
              {/* <EditOutlined onClick={onExpensesEditClick} style={{ color: "#595959", cursor: "pointer" }} /> */}
            </Row>
          }

          className="mb30 card-section custom"
        >
          <div className="">
            <Row gutter={[16, 16]}>
              {[
                { label: "Mortgage or Rental Payments (P&I)", field: "MortgageOrRentalPayment" },
                { label: "Loan Payments (Excluding Mortgages)", field: "LoanPayment" },
                { label: "Property Taxes/Assessments", field: "PropertyTax" },
                { label: "Taxes (City, State, Federal)", field: "Taxes" },
                { label: "Insurance Premiums", field: "InsurancePremium" },
                { label: "Alimony, Child Support, Maintenance", field: "Aluminy_ChildSupport_Maintainance" },
                { label: "Living Expenses", field: "LivingExpenses" },
                { label: "Other Expense", field: "OtherExpenses" },
              ].map(({ label, field }) => (
                <Col span={8} key={field}>
                  {canSeeAdjustments ? (
                    <AdjustmentField
                      label={label}
                      asSubmittedValue={expensesDetails && expensesDetails[field]}
                      adjustment={findAdjustment(AdjustmentTableName.ApplicantExpenses, field)}
                      canEdit={canEditAdjustments}
                      onSave={(value, reason) =>
                        handleSaveAdjustment(AdjustmentScreenModule.Expenses, AdjustmentTableName.ApplicantExpenses, field, null, value, reason)
                      }
                      onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantExpenses, field, null)}
                    />
                  ) : (
                    <>
                      <Text type="secondary">{label}</Text>
                      <div className="b-bottm">{expensesDetails && expensesDetails[field] ? `$ ${_commonService.formatNumberWithCommas(expensesDetails[field])}` : "N/A"}</div>
                    </>
                  )}
                </Col>
              ))}
              <Col span={8}>
                {canSeeAdjustments ? (
                  // Read-only, same as the Income Sources Total field: no onSave/onViewHistory, so
                  // no edit/history icon, but the "Adjusted" block still appears automatically once
                  // RecalculateExpenseTotal has recorded one.
                  <AdjustmentField
                    label="Total"
                    asSubmittedValue={expensesDetails && expensesDetails.ExpenseTotal}
                    adjustment={findAdjustment(AdjustmentTableName.ApplicantExpenses, "ExpenseTotal")}
                    canEdit={false}
                  />
                ) : (
                  <>
                    <Text type="secondary">Total</Text>
                    <div className="b-bottm">{expensesDetails && expensesDetails.ExpenseTotal ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.ExpenseTotal)}` : "N/A"}</div>
                  </>
                )}
              </Col>
            </Row>
            <CommentSection CommentSectionName="expenses" applicationstatusid={applicationstatusid} applicantDetails={applicantDetails} ApplicationObjId={ApplicationObjId} />
          </div>
        </Card>
        <Card
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}><WalletOutlined /></span>
                Balance Sheet - Assets (Liquid/Marketable Assets)
              </Text>
              {canSeeAdjustments ? (
                // Read-only, same as the Income Sources/Expenses Total fields: no onSave/onViewHistory,
                // so no edit/history icon, but the "Adjusted" block appears automatically once
                // RecalculateLiquidMarketableAssetsTotal has recorded one.
                <AdjustmentField
                  label=""
                  asSubmittedValue={financialStatementDataDetails?.LiquidMarketableAssetsTotal}
                  adjustment={findAdjustment(AdjustmentTableName.Applicant, "LiquidMarketableAssetsTotal")}
                  canEdit={false}
                />
              ) : (
                <Text strong>
                  {financialStatementDataDetails && financialStatementDataDetails.LiquidMarketableAssetsTotal
                    ? `$${_commonService.formatNumberWithCommas(financialStatementDataDetails.LiquidMarketableAssetsTotal)}`
                    : "N/A"}
                </Text>
              )}
              {/* <EditOutlined onClick={onBalanceSheetAssetsEditClick} style={{ color: "#595959", cursor: "pointer" }} /> */}
            </Row>
          }
          className="mb30 card-section custom"
        >
          <div className="">
            <Collapse
              accordion
              expandIconPosition="end"
              ghost
              collapsible="icon"
              style={{ backgroundColor: "transparent" }}
              onChange={handleCollapseCashShortTermInvestmentChange}
            >
              <CollapsePanel
                key="1"
                style={{ backgroundColor: "transparent" }}
                header={
                  <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                    <Col>
                      <Text strong>Cash & Short-Term Investments</Text>
                    </Col>
                    <Col>
                      {canSeeAdjustments ? (
                        <AdjustmentField
                          label=""
                          asSubmittedValue={financialStatementDataDetails?.CashShortTermInvestmentsTotal}
                          adjustment={findAdjustment(AdjustmentTableName.Applicant, "CashShortTermInvestmentsTotal")}
                          canEdit={canEditAdjustments}
                          onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetAsset, AdjustmentTableName.Applicant, "CashShortTermInvestmentsTotal", null, value, reason)}
                          onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "CashShortTermInvestmentsTotal", null)}
                        />
                      ) : (
                        <Text strong>
                          {financialStatementDataDetails && financialStatementDataDetails.CashShortTermInvestmentsTotal
                            ? `$${_commonService.formatNumberWithCommas(financialStatementDataDetails.CashShortTermInvestmentsTotal)}`
                            : "N/A"}
                        </Text>
                      )}
                    </Col>
                  </Row>
                }
              >
                {cashShortTermInvestmentDetails?.map((item) => (
                  <Card
                    key={item.Id}
                    size="small"
                    type="inner"
                    // style={{ marginBottom: 16, borderRadius: 8 }}
                    // bodyStyle={{ padding: 16 }}
                    className="mb30 card-section custom"
                  >
                    {console.log("item", item)}
                    <div className="">
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Text type="secondary">Financial Institution</Text>
                          <div>{item.FinInstitutionalName == "" ? "N/A" : item.FinInstitutionalName}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Account Type </Text>
                          <div>{item.TypeOfAccount ? item.TypeOfAccount : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Owner</Text>
                          <div>{item.Owner ? item.Owner : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Pledged To</Text>
                          <div>{item.PledgeToWhome ? item.PledgeToWhome : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          {canSeeAdjustments ? (
                            <AdjustmentField
                              label="Total Amount"
                              asSubmittedValue={item.Total}
                              adjustment={findAdjustment(AdjustmentTableName.ApplicantCashShortTermInvestments, "Total", item.Id)}
                              canEdit={canEditAdjustments}
                              onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetAsset, AdjustmentTableName.ApplicantCashShortTermInvestments, "Total", item.Id, value, reason)}
                              onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantCashShortTermInvestments, "Total", item.Id)}
                            />
                          ) : (
                            <>
                              <Text type="secondary">Total Amount</Text>
                              <div>{item.Total ? `${_commonService.formatNumberWithCommas(item.Total)}` : "N/A"}</div>
                            </>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </Card>
                ))}
              </CollapsePanel>
            </Collapse>


            <Collapse
              accordion
              expandIconPosition="end"
              ghost
              collapsible="icon"
              style={{ backgroundColor: "transparent" }}
              onChange={handleCollapseListedStockAndBondChange}
            >
              <CollapsePanel
                key="2"
                style={{ backgroundColor: "transparent" }}
                header={
                  <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                    <Col>
                      <Text strong>Listed Stocks and Bonds & Gov't Securities</Text>
                    </Col>
                    <Col>
                      {canSeeAdjustments ? (
                        <AdjustmentField
                          label=""
                          asSubmittedValue={financialStatementDataDetails?.StockBondGovSecurityTotal}
                          adjustment={findAdjustment(AdjustmentTableName.Applicant, "StockBondGovSecurityTotal")}
                          canEdit={canEditAdjustments}
                          onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetAsset, AdjustmentTableName.Applicant, "StockBondGovSecurityTotal", null, value, reason)}
                          onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "StockBondGovSecurityTotal", null)}
                        />
                      ) : (
                        <Text strong>{financialStatementDataDetails.StockBondGovSecurityTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.StockBondGovSecurityTotal)}` : "N/A"}</Text>
                      )}
                    </Col>
                  </Row>
                }
              >
                {listedStockAndBondsDetails?.map((item) => (
                  <Card
                    key={item.Id}
                    size="small"
                    type="inner"
                    // style={{ marginBottom: 16, borderRadius: 8 }}
                    // bodyStyle={{ padding: 16 }}
                    className="mb30 card-section custom"
                  >
                    <Row gutter={[16, 16]}>
                      <Col span={8}>
                        <Text type="secondary">No. Shares or Par Value of Bonds, Notes, Bills</Text>
                        <div>{item.SharesOrParValueBonds_Notes_Bills ? item.SharesOrParValueBonds_Notes_Bills : "N/A"}</div>
                      </Col>
                      <Col span={8}>
                        <Text type="secondary">Which Exchange</Text>
                        <div>{item.WhichExchage ? item.WhichExchage : "N/A"}</div>
                      </Col>
                      <Col span={8}>
                        <Text type="secondary">Description</Text>
                        <div>{item.Description ? item.Description : "N/A"}</div>
                      </Col>
                      <Col span={8}>
                        <Text type="secondary">Owner</Text>
                        <div>{item.Owner ? item.Owner : "N/A"}</div>
                      </Col>
                      <Col span={8}>
                        <Text type="secondary">Cost Basis</Text>
                        <div>{item.CoastBasis ? `$${_commonService.formatNumberWithCommas(item.CoastBasis)}` : "N/A"}</div>
                      </Col>
                      <Col span={8}>
                        {canSeeAdjustments ? (
                          <AdjustmentField
                            label="Market Value"
                            asSubmittedValue={item.MarketValue}
                            adjustment={findAdjustment(AdjustmentTableName.ApplicantStockBondGovSecurity, "MarketValue", item.Id)}
                            canEdit={canEditAdjustments}
                            onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetAsset, AdjustmentTableName.ApplicantStockBondGovSecurity, "MarketValue", item.Id, value, reason)}
                            onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantStockBondGovSecurity, "MarketValue", item.Id)}
                          />
                        ) : (
                          <>
                            <Text type="secondary">Market Value</Text>
                            <div>{item.MarketValue ? `$${_commonService.formatNumberWithCommas(item.MarketValue)}` : "N/A"}</div>
                          </>
                        )}
                      </Col>
                      <Col span={8}>
                        <Text type="secondary">If Pledged, to whom?</Text>
                        <div>{item.PledgeToWhome ? item.PledgeToWhome : "N/A"}</div>
                      </Col>
                    </Row>
                  </Card>
                ))}
              </CollapsePanel>
            </Collapse>

            <Collapse
              accordion
              expandIconPosition="end"
              ghost
              collapsible="icon"
              style={{ backgroundColor: "transparent" }}
              onChange={handleCollapseChangeAccountNotesReceivable}
            >
              <CollapsePanel
                key="3"
                style={{ backgroundColor: "transparent" }}
                header={
                  <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                    <Col>
                      <Text strong>Accounts and Notes Receivable</Text>
                    </Col>
                    <Col>
                      {canSeeAdjustments ? (
                        <AdjustmentField
                          label=""
                          asSubmittedValue={financialStatementDataDetails?.AccountNoteReceivableTotal}
                          adjustment={findAdjustment(AdjustmentTableName.Applicant, "AccountNoteReceivableTotal")}
                          canEdit={canEditAdjustments}
                          onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetAsset, AdjustmentTableName.Applicant, "AccountNoteReceivableTotal", null, value, reason)}
                          onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "AccountNoteReceivableTotal", null)}
                        />
                      ) : (
                        <Text strong>{financialStatementDataDetails?.AccountNoteReceivableTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.AccountNoteReceivableTotal)}` : "N/A"}</Text>
                      )}
                    </Col>
                  </Row>
                }
              >
                {accountsandNotesReceivableDetails?.map((item) => (
                  <Card
                    key={item.Id}
                    size="small"
                    type="inner"
                    // style={{ marginBottom: 16, borderRadius: 8 }}
                    // bodyStyle={{ padding: 16 }}
                    className="mb30 card-section custom"
                  >
                    <Row gutter={[16, 16]}>
                      <Col span={8}>
                        <Text type="secondary">Name of Debtor</Text>
                        <div>{item.NameOfDebtor ? item.NameOfDebtor : "N/A"}</div>
                      </Col>
                      <Col span={8}>
                        <Text type="secondary">Collateral</Text>
                        <div>{item.Collateral ? `$ ${_commonService.formatNumberWithCommas(item.Collateral)}` : "N/A"}</div>
                      </Col>
                      <Col span={8}>
                        <Text type="secondary">Interest Rate</Text>
                        <div>{item.InterestRate ? item.InterestRate : "N/A"}</div>
                      </Col>
                      <Col span={8}>
                        <Text type="secondary">Payable</Text>
                        <div>{item.Payble ? `$ ${_commonService.formatNumberWithCommas(item.Payble)}` : "N/A"}</div>
                      </Col>
                      <Col span={8}>
                        <Text type="secondary">Maturity Date</Text>
                        <div>{item.MaturityDate ? `$ ${_commonService.convertToMMDDYYYY(item.MaturityDate)}` : "N/A"}</div>
                      </Col>
                      <Col span={8}>
                        {canSeeAdjustments ? (
                          <AdjustmentField
                            label="Unpaid Balance"
                            asSubmittedValue={item.UnpaidBalance}
                            adjustment={findAdjustment(AdjustmentTableName.ApplicantAccountNoteReceivable, "UnpaidBalance", item.Id)}
                            canEdit={canEditAdjustments}
                            onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetAsset, AdjustmentTableName.ApplicantAccountNoteReceivable, "UnpaidBalance", item.Id, value, reason)}
                            onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantAccountNoteReceivable, "UnpaidBalance", item.Id)}
                          />
                        ) : (
                          <>
                            <Text type="secondary">Unpaid Balance</Text>
                            <div>{item.UnpaidBalance ? `$ ${_commonService.formatNumberWithCommas(item.UnpaidBalance)}` : "N/A"}</div>
                          </>
                        )}
                      </Col>
                      <Col span={8}>
                        <Text type="secondary">If Pledged, to whom?</Text>
                        <div>{item.PledgeToWhome ? item.PledgeToWhome : "N/A"}</div>
                      </Col>
                    </Row>
                  </Card>
                ))}
              </CollapsePanel>
            </Collapse>

            <Collapse
              accordion
              expandIconPosition="end"
              ghost
              collapsible="icon"
              style={{ backgroundColor: "transparent" }}
              onChange={handleCollapseCashValueLifeInsurance}
            >
              <CollapsePanel
                key="4"
                style={{ backgroundColor: "transparent" }}
                header={
                  <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                    <Col>
                      <Text strong>Cash Value (Net of Policy Loans) Life Insurance</Text>
                    </Col>
                    <Col>
                      {canSeeAdjustments ? (
                        <AdjustmentField
                          label=""
                          asSubmittedValue={financialStatementDataDetails?.CashValueLifeInsuranceTotal}
                          adjustment={findAdjustment(AdjustmentTableName.Applicant, "CashValueLifeInsuranceTotal")}
                          canEdit={canEditAdjustments}
                          onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetAsset, AdjustmentTableName.Applicant, "CashValueLifeInsuranceTotal", null, value, reason)}
                          onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "CashValueLifeInsuranceTotal", null)}
                        />
                      ) : (
                        <Text strong>{financialStatementDataDetails && financialStatementDataDetails.CashValueLifeInsuranceTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.CashValueLifeInsuranceTotal)}` : "N/A"}</Text>
                      )}
                    </Col>
                  </Row>
                }
              >
                {cashValueLifeInsuranceDetails?.map((item) => (
                  <Card
                    key={item.Id}
                    size="small"
                    type="inner"
                    // style={{ marginBottom: 16, borderRadius: 8 }}
                    // bodyStyle={{ padding: 16 }}
                    className="mb30 card-section custom"
                  >
                    <Row gutter={[16, 16]}>
                      <Col span={8}>
                        <Text type="secondary">Name of Company</Text>
                        <div>{item.NameOfCompany ? item.NameOfCompany : "N/A"}</div>
                      </Col>
                      <Col span={8}>
                        <Text type="secondary">Beneficiary</Text>
                        <div>{item.Beneficiary ? item.Beneficiary : "N/A"}</div>
                      </Col>
                      <Col span={8}>
                        <Text type="secondary">Owner</Text>
                        <div>{item.Owner ? item.Owner : "N/A"}</div>
                      </Col>
                      <Col span={8}>
                        <Text type="secondary">Loans</Text>
                        <div>{item.Loans ? `$ ${_commonService.formatNumberWithCommas(item.Loans)}` : "N/A"}</div>
                      </Col>
                      <Col span={8}>
                        <Text type="secondary">Cash Value</Text>
                        <div>{item.CashValue ? `$ ${_commonService.formatNumberWithCommas(item.CashValue)}` : "N/A"}</div>
                      </Col>
                      <Col span={8}>
                        {canSeeAdjustments ? (
                          <AdjustmentField
                            label="Amount"
                            asSubmittedValue={item.Amount}
                            adjustment={findAdjustment(AdjustmentTableName.ApplicantCashValueLifeInsurance, "Amount", item.Id)}
                            canEdit={canEditAdjustments}
                            onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetAsset, AdjustmentTableName.ApplicantCashValueLifeInsurance, "Amount", item.Id, value, reason)}
                            onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantCashValueLifeInsurance, "Amount", item.Id)}
                          />
                        ) : (
                          <>
                            <Text type="secondary">Amount</Text>
                            <div>{item.Amount ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}` : "N/A"}</div>
                          </>
                        )}
                      </Col>
                    </Row>
                  </Card>
                ))}
              </CollapsePanel>
            </Collapse>

            {renderStaticAdjustmentRow("Other Liquid Assets", financialStatementDataDetails.OtherLiquidAssetsTotal, "OtherLiquidAssetsTotal", AdjustmentScreenModule.BalanceSheetAsset)}

            <CommentSection CommentSectionName="balancesheetasset" applicationstatusid={applicationstatusid} applicantDetails={applicantDetails} ApplicationObjId={ApplicationObjId} />
          </div>
        </Card>
        <Card
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}><TagsOutlined /></span>
                Balance Sheet -Total Assets
              </Text>
              {canSeeAdjustments ? (
                // Read-only, same as the other Total fields: no onSave/onViewHistory, so no
                // edit/history icon, but the "Adjusted" block appears automatically once
                // RecalculateAssetsTotal has recorded one.
                <AdjustmentField
                  label=""
                  asSubmittedValue={financialStatementDataDetails?.AssetsTotal}
                  adjustment={findAdjustment(AdjustmentTableName.Applicant, "AssetsTotal")}
                  canEdit={false}
                />
              ) : (
                <Text strong>{financialStatementDataDetails.AssetsTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.AssetsTotal)}` : "N/A"}</Text>
              )}
              {/* <EditOutlined onClick={onBalanceSheetTotalAssetsEditClick} style={{ color: "#595959", cursor: "pointer" }} /> */}
            </Row>
          }

          className="mb30 card-section custom"
        >
          <div className="">
            <Collapse
              accordion
              expandIconPosition="end"
              ghost
              collapsible="icon"
              style={{ backgroundColor: "transparent" }}
              onChange={handleCollapseOwnPersonalResidence}
            >
              <CollapsePanel
                key="5"
                style={{ backgroundColor: "transparent" }}
                header={
                  <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                    <Col>
                      <Text strong>RE Owned - Personal Residence (S) - Total</Text>
                    </Col>
                    <Col>
                      {canSeeAdjustments ? (
                        <AdjustmentField
                          label=""
                          asSubmittedValue={financialStatementDataDetails?.OwnPersonalResidenceTotal}
                          adjustment={findAdjustment(AdjustmentTableName.Applicant, "OwnPersonalResidenceTotal")}
                          canEdit={canEditAdjustments}
                          onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetPersonalHolding, AdjustmentTableName.Applicant, "OwnPersonalResidenceTotal", null, value, reason)}
                          onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "OwnPersonalResidenceTotal", null)}
                        />
                      ) : (
                        <Text strong>{financialStatementDataDetails.OwnPersonalResidenceTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.OwnPersonalResidenceTotal)}` : "N/A"}</Text>
                      )}
                    </Col>
                  </Row>
                }
              >
                {

                  ownPersonalResidenceDetails?.map((item) => (
                    <Card
                      key={item.Id}
                      size="small"
                      type="inner"
                      // style={{ marginBottom: 16, borderRadius: 8 }}
                      // bodyStyle={{ padding: 16 }}
                      className="mb30 card-section custom"
                    >

                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Text type="secondary">Property & Location</Text>
                          <div>{item.PropertyAndLocation ? item.PropertyAndLocation : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Owner</Text>
                          <div>{item.Owner ? item.Owner : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Date Acquired</Text>
                          <div>{item.DateAcquired ? _commonService.convertToMMDDYYYY(item.DateAcquired) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Cost</Text>
                          <div>{item.Cost ? `$ ${_commonService.formatNumberWithCommas(item.Cost)}` : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          {canSeeAdjustments ? (
                            <AdjustmentField
                              label="Market Value"
                              asSubmittedValue={item.MarketValue}
                              adjustment={findAdjustment(AdjustmentTableName.ApplicantOwnPersonalResidence, "MarketValue", item.Id)}
                              canEdit={canEditAdjustments}
                              onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetPersonalHolding, AdjustmentTableName.ApplicantOwnPersonalResidence, "MarketValue", item.Id, value, reason)}
                              onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantOwnPersonalResidence, "MarketValue", item.Id)}
                            />
                          ) : (
                            <>
                              <Text type="secondary">Market Value</Text>
                              <div>{item.MarketValue ? `$ ${_commonService.formatNumberWithCommas(item.MarketValue)}` : "N/A"}</div>
                            </>
                          )}
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Mortgagor</Text>
                          <div>{item.Mortgagor ? item.Mortgagor : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Maturity Date</Text>
                          <div>{item.Maturity ? _commonService.convertToMMDDYYYY(item.Maturity) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Amount</Text>
                          <div>{item.Amount ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}` : "N/A"}</div>
                        </Col>
                      </Row>

                    </Card>
                  ))
                }


              </CollapsePanel>
            </Collapse>


            <Collapse
              accordion
              expandIconPosition="end"
              ghost
              collapsible="icon"
              style={{ backgroundColor: "transparent" }}
              onChange={handleCollapseestedIntrestPension}
            >
              <CollapsePanel
                key="6"
                style={{ backgroundColor: "transparent" }}
                header={
                  <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                    <Col>
                      <Text strong>Vested Interest in Pension/Profit Share/Deferred Comp</Text>
                    </Col>
                    <Col>
                      {canSeeAdjustments ? (
                        <AdjustmentField
                          label=""
                          asSubmittedValue={financialStatementDataDetails?.VestedIntrestPensionTotal}
                          adjustment={findAdjustment(AdjustmentTableName.Applicant, "VestedIntrestPensionTotal")}
                          canEdit={canEditAdjustments}
                          onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetPersonalHolding, AdjustmentTableName.Applicant, "VestedIntrestPensionTotal", null, value, reason)}
                          onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "VestedIntrestPensionTotal", null)}
                        />
                      ) : (
                        <Text strong>{financialStatementDataDetails.VestedIntrestPensionTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.VestedIntrestPensionTotal)}` : "N/A"}</Text>
                      )}
                    </Col>
                  </Row>
                }
              >
                {

                  vestedIntrestPensionDetails?.map((item) => (
                    <Card
                      key={item.Id}
                      size="small"
                      type="inner"
                      // style={{ marginBottom: 16, borderRadius: 8 }}
                      // bodyStyle={{ padding: 16 }}
                      className="mb30 card-section custom"
                    >
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Text type="secondary">Name of Company</Text>
                          <div>{item.NameOfCompany ? item.NameOfCompany : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Owner</Text>
                          <div>{item.Owner ? item.Owner : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Beneficiary</Text>
                          <div>{item.Beneficiary ? item.Beneficiary : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Payout Basis</Text>
                          <div>{item.PayoutBasis ? item.PayoutBasis : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Date Available</Text>
                          <div>{item.AvailableDate ? _commonService.convertToMMDDYYYY(item.AvailableDate) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          {canSeeAdjustments ? (
                            <AdjustmentField
                              label="Amount"
                              asSubmittedValue={item.Amount}
                              adjustment={findAdjustment(AdjustmentTableName.ApplicantVestedIntrestPension, "Amount", item.Id)}
                              canEdit={canEditAdjustments}
                              onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetPersonalHolding, AdjustmentTableName.ApplicantVestedIntrestPension, "Amount", item.Id, value, reason)}
                              onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantVestedIntrestPension, "Amount", item.Id)}
                            />
                          ) : (
                            <>
                              <Text type="secondary">Amount</Text>
                              <div>{item.Amount ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}` : "N/A"}</div>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Card>
                  ))
                }


              </CollapsePanel>
            </Collapse>

            <Collapse
              accordion
              expandIconPosition="end"
              ghost
              collapsible="icon"
              style={{ backgroundColor: "transparent" }}
              onChange={handleCollapUnListedStocks}
            >
              <CollapsePanel
                key="7"
                style={{ backgroundColor: "transparent" }}
                header={
                  <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                    <Col>
                      <Text strong>Unlisted Stocks – Total Accounts and Notes Receivable</Text>
                    </Col>
                    <Col>
                      {canSeeAdjustments ? (
                        <AdjustmentField
                          label=""
                          asSubmittedValue={financialStatementDataDetails?.UnListedStocksTotal}
                          adjustment={findAdjustment(AdjustmentTableName.Applicant, "UnListedStocksTotal")}
                          canEdit={canEditAdjustments}
                          onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetPersonalHolding, AdjustmentTableName.Applicant, "UnListedStocksTotal", null, value, reason)}
                          onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "UnListedStocksTotal", null)}
                        />
                      ) : (
                        <Text strong>{financialStatementDataDetails.UnListedStocksTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.UnListedStocksTotal)}` : "N/A"}</Text>
                      )}
                    </Col>
                  </Row>
                }
              >
                {

                  unListedStocksDetails?.map((item) => (
                    <Card
                      key={item.Id}
                      size="small"
                      type="inner"
                      // style={{ marginBottom: 16, borderRadius: 8 }}
                      // bodyStyle={{ padding: 16 }}
                      className="mb30 card-section custom"
                    >
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Text type="secondary">Description of Securities</Text>
                          <div>{item.DescriptionOfSecurity ? item.DescriptionOfSecurity : "N/A"}</div>
                        </Col>
                        {/* <Col span={8}>
                      <Text type="secondary">In Name Of, No. of Shares Owned</Text>
                      <div>{item.InNameOf ? item.InNameOf :"N/A"}</div>
                    </Col> */}
                        <Col span={8}>
                          <Text type="secondary">Number of Shares Owned</Text>
                          <div>{item.InNameOf ? item.InNameOf : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Ownership</Text>
                          <div>{item.OwenershipPercentage ? item.OwenershipPercentage : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Book Value</Text>
                          <div>{item.BookValue ? `$ ${_commonService.formatNumberWithCommas(item.BookValue)}` : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          {canSeeAdjustments ? (
                            <AdjustmentField
                              label="Book Value Amount"
                              asSubmittedValue={item.BookValueAmount}
                              adjustment={findAdjustment(AdjustmentTableName.ApplicantUnListedStocks, "BookValueAmount", item.Id)}
                              canEdit={canEditAdjustments}
                              onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetPersonalHolding, AdjustmentTableName.ApplicantUnListedStocks, "BookValueAmount", item.Id, value, reason)}
                              onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantUnListedStocks, "BookValueAmount", item.Id)}
                            />
                          ) : (
                            <>
                              <Text type="secondary">Book Value Amount</Text>
                              <div>{item.BookValueAmount ? `$ ${_commonService.formatNumberWithCommas(item.BookValueAmount)}` : "N/A"}</div>
                            </>
                          )}
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">If Pledged, To Whom?</Text>
                          <div>{item.PledgeToWhome ? item.PledgeToWhome : "N/A"}</div>
                        </Col>
                      </Row>
                    </Card>
                  ))
                }


              </CollapsePanel>
            </Collapse>


            <Collapse
              accordion
              expandIconPosition="end"
              ghost
              collapsible="icon"
              style={{ backgroundColor: "transparent" }}
              onChange={handleCollapReInvestment}
            >
              <CollapsePanel
                key="8"
                style={{ backgroundColor: "transparent" }}
                header={
                  <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                    <Col>
                      <Text strong>RE Investments</Text>
                    </Col>
                    <Col>
                      {canSeeAdjustments ? (
                        <AdjustmentField
                          label=""
                          asSubmittedValue={financialStatementDataDetails?.InvestmentTotal}
                          adjustment={findAdjustment(AdjustmentTableName.Applicant, "InvestmentTotal")}
                          canEdit={canEditAdjustments}
                          onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetPersonalHolding, AdjustmentTableName.Applicant, "InvestmentTotal", null, value, reason)}
                          onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "InvestmentTotal", null)}
                        />
                      ) : (
                        <Text strong>{financialStatementDataDetails.InvestmentTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.InvestmentTotal)}` : "N/A"}</Text>
                      )}
                    </Col>
                  </Row>
                }
              >
                {

                  reInvestmentDetails?.map((item) => (
                    <Card
                      key={item.Id}
                      size="small"
                      type="inner"
                      // style={{ marginBottom: 16, borderRadius: 8 }}
                      // bodyStyle={{ padding: 16 }}
                      className="mb30 card-section custom"
                    >
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Text type="secondary">Property & Location</Text>
                          <div>{item.PropertyAndLocation ? item.PropertyAndLocation : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Owner</Text>
                          <div>{item.Owner ? item.Owner : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Date Acquired</Text>
                          <div>{item.DateAcquired ? _commonService.convertToMMDDYYYY(item.DateAcquired) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Cost</Text>
                          <div>{item.Cost ? `$ ${_commonService.formatNumberWithCommas(item.Cost)}` : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          {canSeeAdjustments ? (
                            <AdjustmentField
                              label="Market Value"
                              asSubmittedValue={item.MarketValue}
                              adjustment={findAdjustment(AdjustmentTableName.ApplicantInvestment, "MarketValue", item.Id)}
                              canEdit={canEditAdjustments}
                              onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetPersonalHolding, AdjustmentTableName.ApplicantInvestment, "MarketValue", item.Id, value, reason)}
                              onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantInvestment, "MarketValue", item.Id)}
                            />
                          ) : (
                            <>
                              <Text type="secondary">Market Value</Text>
                              <div>{item.MarketValue ? `$ ${_commonService.formatNumberWithCommas(item.MarketValue)}` : "N/A"}</div>
                            </>
                          )}
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Mortgagor</Text>
                          <div>{item.Mortgagor ? item.Mortgagor : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Maturity Date</Text>
                          <div>{item.Maturity ? _commonService.convertToMMDDYYYY(item.Maturity) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Amount</Text>
                          <div>{item.Amount ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}` : "N/A"}</div>
                        </Col>
                      </Row>
                    </Card>
                  ))
                }


              </CollapsePanel>
            </Collapse>

            <Collapse
              accordion
              expandIconPosition="end"
              ghost
              collapsible="icon"
              style={{ backgroundColor: "transparent" }}
              onChange={handleCollapgeneralAndLimitedPartenership}
            >
              <CollapsePanel
                key="9"
                style={{ backgroundColor: "transparent" }}
                header={
                  <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                    <Col>
                      <Text strong>General and/or Limited Partnership Interests</Text>
                    </Col>
                    <Col>
                      {canSeeAdjustments ? (
                        <AdjustmentField
                          label=""
                          asSubmittedValue={financialStatementDataDetails?.GeneralAndLimitedPartenershipIntrestTotal}
                          adjustment={findAdjustment(AdjustmentTableName.Applicant, "GeneralAndLimitedPartenershipIntrestTotal")}
                          canEdit={canEditAdjustments}
                          onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetPersonalHolding, AdjustmentTableName.Applicant, "GeneralAndLimitedPartenershipIntrestTotal", null, value, reason)}
                          onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "GeneralAndLimitedPartenershipIntrestTotal", null)}
                        />
                      ) : (
                        <Text strong>{financialStatementDataDetails.GeneralAndLimitedPartenershipIntrestTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.GeneralAndLimitedPartenershipIntrestTotal)}` : "N/A"}</Text>
                      )}
                    </Col>
                  </Row>
                }
              >
                {

                  generalAndLimitedPartenershipDetails?.map((item) => (
                    <Card
                      key={item.Id}
                      size="small"
                      type="inner"
                      // style={{ marginBottom: 16, borderRadius: 8 }}
                      // bodyStyle={{ padding: 16 }}
                      className="mb30 card-section custom"
                    >
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Text type="secondary">Name of Partnership</Text>
                          <div>{item.NameOfPartenership ? item.NameOfPartenership : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Type of Investment</Text>
                          <div>{item.TypeOfInvestment ? item.TypeOfInvestment : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Limited or General Partnership Interest</Text>
                          <div>{item.LimitedOrGeneral ? item.LimitedOrGeneral : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Amount Invested</Text>
                          <div>{item.AmountInvested ? `$ ${_commonService.formatNumberWithCommas(item.AmountInvested)}` : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          {canSeeAdjustments ? (
                            <AdjustmentField
                              label="Fair Market Value of Partnership Interest"
                              asSubmittedValue={item.FairMarketValue}
                              adjustment={findAdjustment(AdjustmentTableName.ApplicantGeneralAndLimitedPartenershipIntrest, "FairMarketValue", item.Id)}
                              canEdit={canEditAdjustments}
                              onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetPersonalHolding, AdjustmentTableName.ApplicantGeneralAndLimitedPartenershipIntrest, "FairMarketValue", item.Id, value, reason)}
                              onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantGeneralAndLimitedPartenershipIntrest, "FairMarketValue", item.Id)}
                            />
                          ) : (
                            <>
                              <Text type="secondary">Fair Market Value of Partnership Interest</Text>
                              <div>{item.FairMarketValue ? `$ ${_commonService.formatNumberWithCommas(item.FairMarketValue)}` : "N/A"}</div>
                            </>
                          )}
                        </Col>

                      </Row>
                    </Card>
                  ))
                }


              </CollapsePanel>
            </Collapse>
            {renderStaticAdjustmentRow("IRA/Keogh Accounts", financialStatementDataDetails?.IRAKeoghAccountsTotal, "IRAKeoghAccountsTotal", AdjustmentScreenModule.BalanceSheetPersonalHolding)}
            {renderStaticAdjustmentRow("Equity Interest in Business", financialStatementDataDetails?.EquityInterestInBusinessTotal, "EquityInterestInBusinessTotal", AdjustmentScreenModule.BalanceSheetPersonalHolding)}
            {renderStaticAdjustmentRow("Personal Property", financialStatementDataDetails?.PersonalPropertyTotal, "PersonalPropertyTotal", AdjustmentScreenModule.BalanceSheetPersonalHolding)}
            {renderStaticAdjustmentRow("Other Assets", financialStatementDataDetails?.OtherAssetsTotal, "OtherAssetsTotal", AdjustmentScreenModule.BalanceSheetPersonalHolding)}

            <CommentSection CommentSectionName="balancesheettotalasset" applicationstatusid={applicationstatusid} applicantDetails={applicantDetails} ApplicationObjId={ApplicationObjId} />
          </div>
        </Card>

        <Card
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}> <ScheduleOutlined /> </span>
                Balance Sheet - Total Liabilities
              </Text>
              {canSeeAdjustments ? (
                // Read-only, same as the other Total fields: no onSave/onViewHistory, so no
                // edit/history icon, but the "Adjusted" block appears automatically once
                // RecalculateLiabilitiesTotal has recorded one.
                <AdjustmentField
                  label=""
                  asSubmittedValue={financialStatementDataDetails?.LiabilitiesTotal}
                  adjustment={findAdjustment(AdjustmentTableName.Applicant, "LiabilitiesTotal")}
                  canEdit={false}
                />
              ) : (
                <Text strong>{financialStatementDataDetails && financialStatementDataDetails.LiabilitiesTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.LiabilitiesTotal)}` : "N/A"}</Text>
              )}
              {/* <EditOutlined onClick={onBalanceSheetTotalLiabilitiesAssetsEditClick} style={{ color: "#595959", cursor: "pointer" }} /> */}
            </Row>
          }

          className="mb30 card-section custom"
        >
          <div className="">
            <Collapse
              accordion
              expandIconPosition="end"
              ghost
              collapsible="icon"
              style={{ backgroundColor: "transparent" }}
              onChange={handleCollapseNotesPayableBankSecured}
            >
              <CollapsePanel
                key="10"
                style={{ backgroundColor: "transparent" }}
                header={
                  <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                    <Col>
                      <Text strong>Notes Payable - Banks Secured</Text>
                    </Col>
                    <Col>
                      {canSeeAdjustments ? (
                        <AdjustmentField
                          label=""
                          asSubmittedValue={financialStatementDataDetails?.NotesPayableBankSecuredTotal}
                          adjustment={findAdjustment(AdjustmentTableName.Applicant, "NotesPayableBankSecuredTotal")}
                          canEdit={canEditAdjustments}
                          onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetLiability, AdjustmentTableName.Applicant, "NotesPayableBankSecuredTotal", null, value, reason)}
                          onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "NotesPayableBankSecuredTotal", null)}
                        />
                      ) : (
                        <Text strong>{financialStatementDataDetails.NotesPayableBankSecuredTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.NotesPayableBankSecuredTotal)}` : "N/A"}</Text>
                      )}
                    </Col>
                  </Row>
                }
              >
                {
                  notesPayableBankSecuredDetails?.map((item) => (
                    <Card
                      key={item.Id}
                      size="small"
                      type="inner"
                      // style={{ marginBottom: 16, borderRadius: 8 }}
                      // bodyStyle={{ padding: 16 }}
                      className="mb30 card-section custom"
                    >
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Text type="secondary">To Whom?</Text>
                          <div>{item.ToWhom ? item.ToWhom : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Payment Amount</Text>
                          <div>{item.PaymentAmount ? `$ ${_commonService.formatNumberWithCommas(item.PaymentAmount)}` : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Monthly/Quarterly/Semi-Annual/Annually</Text>
                          <div>{item.MonthlyQuaterlyAnnually ? item.MonthlyQuaterlyAnnually : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Opening Date</Text>
                          <div>{item.OpeningDate ? _commonService.convertToMMDDYYYY(item.OpeningDate) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Maturity Date</Text>
                          <div>{item.MaturityDate ? _commonService.convertToMMDDYYYY(item.MaturityDate) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Description of Collateral</Text>
                          <div>{item.DescriptionOfCollateral ? item.DescriptionOfCollateral : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          {canSeeAdjustments ? (
                            <AdjustmentField
                              label="Balance (Secured)"
                              asSubmittedValue={item.Balance_Secured}
                              adjustment={findAdjustment(AdjustmentTableName.ApplicantNotesPayableBankSecured, "Balance_Secured", item.Id)}
                              canEdit={canEditAdjustments}
                              onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetLiability, AdjustmentTableName.ApplicantNotesPayableBankSecured, "Balance_Secured", item.Id, value, reason)}
                              onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantNotesPayableBankSecured, "Balance_Secured", item.Id)}
                            />
                          ) : (
                            <>
                              <Text type="secondary">Balance (Secured)</Text>
                              <div>{item.Balance_Secured ? `$ ${_commonService.formatNumberWithCommas(item.Balance_Secured)}` : "N/A"}</div>
                            </>
                          )}
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Balance (Unsecured)</Text>
                          <div>{item.Balance_UnSecured ? `$ ${_commonService.formatNumberWithCommas(item.Balance_UnSecured)}` : "N/A"}</div>
                        </Col>
                      </Row>
                    </Card>
                  ))
                }
              </CollapsePanel>
            </Collapse>
            <Collapse
              accordion
              expandIconPosition="end"
              ghost
              collapsible="icon"
              style={{ backgroundColor: "transparent" }}
              onChange={handleCollapseNotesPayableBankUnSecured}
            >
              <CollapsePanel
                key="11"
                style={{ backgroundColor: "transparent" }}
                header={
                  <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                    <Col>
                      <Text strong>Notes Payable - Banks Unsecured</Text>
                    </Col>
                    <Col>
                      {canSeeAdjustments ? (
                        <AdjustmentField
                          label=""
                          asSubmittedValue={financialStatementDataDetails?.NotesPayableBankUnSecuredTotal}
                          adjustment={findAdjustment(AdjustmentTableName.Applicant, "NotesPayableBankUnSecuredTotal")}
                          canEdit={canEditAdjustments}
                          onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetLiability, AdjustmentTableName.Applicant, "NotesPayableBankUnSecuredTotal", null, value, reason)}
                          onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "NotesPayableBankUnSecuredTotal", null)}
                        />
                      ) : (
                        <Text strong>{financialStatementDataDetails.NotesPayableBankUnSecuredTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.NotesPayableBankUnSecuredTotal)}` : "N/A"}</Text>
                      )}
                    </Col>
                  </Row>
                }
              >
                {
                  notesPayableBankUnSecuredDetails?.map((item) => (
                    <Card
                      key={item.Id}
                      size="small"
                      type="inner"
                      // style={{ marginBottom: 16, borderRadius: 8 }}
                      // bodyStyle={{ padding: 16 }}
                      className="mb30 card-section custom"
                    >
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Text type="secondary">To Whom?</Text>
                          <div>{item.ToWhom ? item.ToWhom : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Payment Amount</Text>
                          <div>{item.PaymentAmount ? `$ ${_commonService.formatNumberWithCommas(item.PaymentAmount)}` : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Monthly/Quarterly/Semi-Annual/Annually</Text>
                          <div>{item.MonthlyQuaterlyAnnually ? item.MonthlyQuaterlyAnnually : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Opening Date</Text>
                          <div>{item.OpeningDate ? _commonService.convertToMMDDYYYY(item.OpeningDate) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Maturity Date</Text>
                          <div>{item.MaturityDate ? _commonService.convertToMMDDYYYY(item.MaturityDate) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Description of Collateral</Text>
                          <div>{item.DescriptionOfCollateral ? item.DescriptionOfCollateral : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Balance (Secured)</Text>
                          <div>{item.Balance_Secured ? `$ ${_commonService.formatNumberWithCommas(item.Balance_Secured)}` : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          {canSeeAdjustments ? (
                            <AdjustmentField
                              label="Balance (Unsecured)"
                              asSubmittedValue={item.Balance_UnSecured}
                              adjustment={findAdjustment(AdjustmentTableName.ApplicantNotesPayableBankUnSecured, "Balance_UnSecured", item.Id)}
                              canEdit={canEditAdjustments}
                              onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetLiability, AdjustmentTableName.ApplicantNotesPayableBankUnSecured, "Balance_UnSecured", item.Id, value, reason)}
                              onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantNotesPayableBankUnSecured, "Balance_UnSecured", item.Id)}
                            />
                          ) : (
                            <>
                              <Text type="secondary">Balance (Unsecured)</Text>
                              <div>{item.Balance_UnSecured ? `$ ${_commonService.formatNumberWithCommas(item.Balance_UnSecured)}` : "N/A"}</div>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Card>
                  ))
                }
              </CollapsePanel>
            </Collapse>

            <Collapse
              accordion
              expandIconPosition="end"
              ghost
              collapsible="icon"
              style={{ backgroundColor: "transparent" }}
              onChange={handleCollapseChangeNotesPayableOther}
            >
              <CollapsePanel
                key="13"
                style={{ backgroundColor: "transparent" }}
                header={
                  <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                    <Col>
                      <Text strong>Notes Payable - Other</Text>
                    </Col>
                    <Col>
                      {canSeeAdjustments ? (
                        <AdjustmentField
                          label=""
                          asSubmittedValue={financialStatementDataDetails?.NotesPayableOtherTotal}
                          adjustment={findAdjustment(AdjustmentTableName.Applicant, "NotesPayableOtherTotal")}
                          canEdit={canEditAdjustments}
                          onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetLiability, AdjustmentTableName.Applicant, "NotesPayableOtherTotal", null, value, reason)}
                          onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "NotesPayableOtherTotal", null)}
                        />
                      ) : (
                        <Text strong>{financialStatementDataDetails.NotesPayableOtherTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.NotesPayableOtherTotal)}` : "N/A"}</Text>
                      )}
                    </Col>
                  </Row>
                }
              >
                {
                  notesPayableOtherDetails?.map((item) => (
                    <Card
                      key={item.Id}
                      size="small"
                      type="inner"
                      // style={{ marginBottom: 16, borderRadius: 8 }}
                      // bodyStyle={{ padding: 16 }}
                      className="mb30 card-section custom"
                    >
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Text type="secondary">To Whom?</Text>
                          <div>{item.ToWhom ? item.ToWhom : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Payment Amount</Text>
                          <div>{item.PaymentAmount ? `$ ${_commonService.formatNumberWithCommas(item.PaymentAmount)}` : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Monthly/Quarterly/Semi-Annual/Annually</Text>
                          <div>{item.MonthlyQuaterlyAnnually ? item.MonthlyQuaterlyAnnually : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Opening Date</Text>
                          <div>{item.OpeningDate ? _commonService.convertToMMDDYYYY(item.OpeningDate) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Maturity Date</Text>
                          <div>{item.MaturityDate ? _commonService.convertToMMDDYYYY(item.MaturityDate) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Description of Collateral</Text>
                          <div>{item.DescriptionOfCollateral ? item.DescriptionOfCollateral : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          {/* Field choice (Balance_Secured vs Balance_UnSecured) is ambiguous for this
                              category from the UI/schema alone -- flagged in BankerAdjustmentExecutionPlan.md
                              Section 3 for client/tech-lead confirmation; defaulting to Balance_Secured. */}
                          {canSeeAdjustments ? (
                            <AdjustmentField
                              label="Balance (Secured)"
                              asSubmittedValue={item.Balance_Secured}
                              adjustment={findAdjustment(AdjustmentTableName.ApplicantNotesPayableOther, "Balance_Secured", item.Id)}
                              canEdit={canEditAdjustments}
                              onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetLiability, AdjustmentTableName.ApplicantNotesPayableOther, "Balance_Secured", item.Id, value, reason)}
                              onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantNotesPayableOther, "Balance_Secured", item.Id)}
                            />
                          ) : (
                            <>
                              <Text type="secondary">Balance (Secured)</Text>
                              <div>{item.Balance_Secured ? `$ ${_commonService.formatNumberWithCommas(item.Balance_Secured)}` : "N/A"}</div>
                            </>
                          )}
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Balance (Unsecured)</Text>
                          <div>{item.Balance_UnSecured ? `$ ${_commonService.formatNumberWithCommas(item.Balance_UnSecured)}` : "N/A"}</div>
                        </Col>
                      </Row>
                    </Card>
                  ))
                }
              </CollapsePanel>
            </Collapse>

            <Collapse
              accordion
              expandIconPosition="end"
              ghost
              collapsible="icon"
              style={{ backgroundColor: "transparent" }}
              onChange={handleCollapseAccountsPayableChange}
            >
              <CollapsePanel
                key="12"
                style={{ backgroundColor: "transparent" }}
                header={
                  <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                    <Col>
                      <Text strong>Accounts Payable</Text>
                    </Col>
                    <Col>
                      {canSeeAdjustments ? (
                        <AdjustmentField
                          label=""
                          asSubmittedValue={financialStatementDataDetails?.AccountsPayableTotal}
                          adjustment={findAdjustment(AdjustmentTableName.Applicant, "AccountsPayableTotal")}
                          canEdit={canEditAdjustments}
                          onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetLiability, AdjustmentTableName.Applicant, "AccountsPayableTotal", null, value, reason)}
                          onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "AccountsPayableTotal", null)}
                        />
                      ) : (
                        <Text strong>{financialStatementDataDetails.AccountsPayableTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.AccountsPayableTotal)}` : "N/A"}</Text>
                      )}
                    </Col>
                  </Row>
                }
              >
                {
                  accountPayableDetails?.map((item) => (
                    <Card
                      key={item.Id}
                      size="small"
                      type="inner"
                      // style={{ marginBottom: 16, borderRadius: 8 }}
                      // bodyStyle={{ padding: 16 }}
                      className="mb30 card-section custom"
                    >
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Text type="secondary">To Whom?</Text>
                          <div>{item.ToWhom ? item.ToWhom : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Payment Amount</Text>
                          <div>{item.PaymentAmount ? `$ ${_commonService.formatNumberWithCommas(item.PaymentAmount)}` : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Monthly/Quarterly/Semi-Annual/Annually</Text>
                          <div>{item.MonthlyQuaterlyAnnually ? item.MonthlyQuaterlyAnnually : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Opening Date</Text>
                          <div>{item.OpeningDate ? _commonService.convertToMMDDYYYY(item.OpeningDate) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Maturity Date</Text>
                          <div>{item.MaturityDate ? _commonService.convertToMMDDYYYY(item.MaturityDate) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Description of Collateral</Text>
                          <div>{item.DescriptionOfCollateral ? item.DescriptionOfCollateral : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          {/* Field choice (Balance_Secured vs Balance_UnSecured) is ambiguous for this
                              category from the UI/schema alone -- flagged in BankerAdjustmentExecutionPlan.md
                              Section 3 for client/tech-lead confirmation; defaulting to Balance_Secured. */}
                          {canSeeAdjustments ? (
                            <AdjustmentField
                              label="Balance (Secured)"
                              asSubmittedValue={item.Balance_Secured}
                              adjustment={findAdjustment(AdjustmentTableName.ApplicantAccountsPayable, "Balance_Secured", item.Id)}
                              canEdit={canEditAdjustments}
                              onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetLiability, AdjustmentTableName.ApplicantAccountsPayable, "Balance_Secured", item.Id, value, reason)}
                              onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantAccountsPayable, "Balance_Secured", item.Id)}
                            />
                          ) : (
                            <>
                              <Text type="secondary">Balance (Secured)</Text>
                              <div>{item.Balance_Secured ? `$ ${_commonService.formatNumberWithCommas(item.Balance_Secured)}` : "N/A"}</div>
                            </>
                          )}
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Balance (Unsecured)</Text>
                          <div>{item.Balance_UnSecured ? `$ ${_commonService.formatNumberWithCommas(item.Balance_UnSecured)}` : "N/A"}</div>
                        </Col>
                      </Row>
                    </Card>
                  ))
                }
              </CollapsePanel>
            </Collapse>

            <Collapse
              accordion
              expandIconPosition="end"
              ghost
              collapsible="icon"
              style={{ backgroundColor: "transparent" }}
              onChange={handleCollapseChangeCreditCardsBalance}
            >
              <CollapsePanel
                key="14"
                style={{ backgroundColor: "transparent" }}
                header={
                  <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                    <Col>
                      <Text strong>Credit Card Balances</Text>
                    </Col>
                    <Col>
                      {canSeeAdjustments ? (
                        <AdjustmentField
                          label=""
                          asSubmittedValue={financialStatementDataDetails?.CreditCardsBalancesTotal}
                          adjustment={findAdjustment(AdjustmentTableName.Applicant, "CreditCardsBalancesTotal")}
                          canEdit={canEditAdjustments}
                          onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetLiability, AdjustmentTableName.Applicant, "CreditCardsBalancesTotal", null, value, reason)}
                          onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "CreditCardsBalancesTotal", null)}
                        />
                      ) : (
                        <Text strong>{financialStatementDataDetails.CreditCardsBalancesTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.CreditCardsBalancesTotal)}` : "N/A"}</Text>
                      )}
                    </Col>
                  </Row>
                }
              >
                {
                  creditCardBalanceDetails?.map((item) => (
                    <Card
                      key={item.Id}
                      size="small"
                      type="inner"
                      // style={{ marginBottom: 16, borderRadius: 8 }}
                      // bodyStyle={{ padding: 16 }}
                      className="mb30 card-section custom"
                    >
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Text type="secondary">To Whom?</Text>
                          <div>{item.ToWhom ? item.ToWhom : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Payment Amount</Text>
                          <div>{item.PaymentAmount ? `$ ${_commonService.formatNumberWithCommas(item.PaymentAmount)}` : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Monthly/Quarterly/Semi-Annual/Annually</Text>
                          <div>{item.MonthlyQuaterlyAnnually ? item.MonthlyQuaterlyAnnually : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Opening Date</Text>

                          <div>{item.OpeningDate ? _commonService.convertToMMDDYYYY(item.OpeningDate) : "N/A"}</div>

                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Maturity Date</Text>
                          <div>{item.MaturityDate ? _commonService.convertToMMDDYYYY(item.MaturityDate) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Description of Collateral</Text>
                          <div>{item.DescriptionOfCollateral ? item.DescriptionOfCollateral : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          {/* Field choice (Balance_Secured vs Balance_UnSecured) is ambiguous for this
                              category from the UI/schema alone -- flagged in BankerAdjustmentExecutionPlan.md
                              Section 3 for client/tech-lead confirmation; defaulting to Balance_Secured. */}
                          {canSeeAdjustments ? (
                            <AdjustmentField
                              label="Balance (Secured)"
                              asSubmittedValue={item.Balance_Secured}
                              adjustment={findAdjustment(AdjustmentTableName.ApplicantCreditCardBalance, "Balance_Secured", item.Id)}
                              canEdit={canEditAdjustments}
                              onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetLiability, AdjustmentTableName.ApplicantCreditCardBalance, "Balance_Secured", item.Id, value, reason)}
                              onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantCreditCardBalance, "Balance_Secured", item.Id)}
                            />
                          ) : (
                            <>
                              <Text type="secondary">Balance (Secured)</Text>
                              <div>{item.Balance_Secured ? `$ ${_commonService.formatNumberWithCommas(item.Balance_Secured)}` : "N/A"}</div>
                            </>
                          )}
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Balance (Unsecured)</Text>
                          <div>{item.Balance_UnSecured ? `$ ${_commonService.formatNumberWithCommas(item.Balance_UnSecured)}` : "N/A"}</div>
                        </Col>
                      </Row>
                    </Card>
                  ))
                }
              </CollapsePanel>
            </Collapse>


            <Collapse
              accordion
              expandIconPosition="end"
              ghost
              collapsible="icon"
              style={{ backgroundColor: "transparent" }}
              onChange={handleCollapseChangeMortagagesDueWihtinOne}
            >
              <CollapsePanel
                key="15"
                style={{ backgroundColor: "transparent" }}
                header={
                  <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                    <Col>
                      <Text strong>Mortgages Due Within 1 Year</Text>
                    </Col>
                    <Col>
                      {canSeeAdjustments ? (
                        <AdjustmentField
                          label=""
                          asSubmittedValue={financialStatementDataDetails?.MortgagesDueWithinOneYearTotal}
                          adjustment={findAdjustment(AdjustmentTableName.Applicant, "MortgagesDueWithinOneYearTotal")}
                          canEdit={canEditAdjustments}
                          onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetLiability, AdjustmentTableName.Applicant, "MortgagesDueWithinOneYearTotal", null, value, reason)}
                          onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "MortgagesDueWithinOneYearTotal", null)}
                        />
                      ) : (
                        <Text strong>{financialStatementDataDetails.MortgagesDueWithinOneYearTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.MortgagesDueWithinOneYearTotal)}` : "N/A"}</Text>
                      )}
                    </Col>
                  </Row>
                }
              >
                {
                  mortgagesDueWithInOneDetails?.map((item) => (
                    <Card
                      key={item.Id}
                      size="small"
                      type="inner"
                      // style={{ marginBottom: 16, borderRadius: 8 }}
                      // bodyStyle={{ padding: 16 }}
                      className="mb30 card-section custom"
                    >
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Text type="secondary">Property & Location</Text>
                          <div>{item.PropertyAndLocation ? item.PropertyAndLocation : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Owner</Text>
                          <div>{item.Owner ? item.Owner : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Date Acquired</Text>
                          <div> {item.DateAcquired ? _commonService.convertToMMDDYYYY(item.DateAcquired) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Cost</Text>
                          <div>{item.Cost ? `$ ${_commonService.formatNumberWithCommas(item.Cost)}` : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Market Value</Text>
                          <div>{item.MarketValue ? `$ ${_commonService.formatNumberWithCommas(item.MarketValue)}` : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Mortgagor</Text>
                          <div>{item.Mortgagor ? item.Mortgagor : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Maturity Date</Text>
                          <div>{item.Maturity ? _commonService.convertToMMDDYYYY(item.Maturity) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          {canSeeAdjustments ? (
                            <AdjustmentField
                              label="Amount"
                              asSubmittedValue={item.Amount}
                              adjustment={findAdjustment(AdjustmentTableName.ApplicantMortgageDueWithin, "Amount", item.Id)}
                              canEdit={canEditAdjustments}
                              onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetLiability, AdjustmentTableName.ApplicantMortgageDueWithin, "Amount", item.Id, value, reason)}
                              onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantMortgageDueWithin, "Amount", item.Id)}
                            />
                          ) : (
                            <>
                              <Text type="secondary">Amount</Text>
                              <div>{item.Amount ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}` : "N/A"}</div>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Card>
                  ))
                }
              </CollapsePanel>
            </Collapse>


            <Collapse
              accordion
              expandIconPosition="end"
              ghost
              collapsible="icon"
              style={{ backgroundColor: "transparent" }}
              onChange={handleCollapseChangeMortagagesDueBeyondOne}
            >
              <CollapsePanel
                key="16"
                style={{ backgroundColor: "transparent" }}
                header={
                  <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                    <Col>
                      <Text strong>Mortgages Due Beyond 1 Year</Text>
                    </Col>
                    <Col>
                      {canSeeAdjustments ? (
                        <AdjustmentField
                          label=""
                          asSubmittedValue={financialStatementDataDetails?.MortgagesDueBeyondOneYearTotal}
                          adjustment={findAdjustment(AdjustmentTableName.Applicant, "MortgagesDueBeyondOneYearTotal")}
                          canEdit={canEditAdjustments}
                          onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetLiability, AdjustmentTableName.Applicant, "MortgagesDueBeyondOneYearTotal", null, value, reason)}
                          onViewHistory={() => handleViewHistory(AdjustmentTableName.Applicant, "MortgagesDueBeyondOneYearTotal", null)}
                        />
                      ) : (
                        <Text strong>{financialStatementDataDetails.MortgagesDueBeyondOneYearTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.MortgagesDueBeyondOneYearTotal)}` : "N/A"}</Text>
                      )}
                    </Col>
                  </Row>
                }
              >
                {
                  mortgagesDueBeyondOneDetails?.map((item) => (
                    <Card
                      key={item.Id}
                      size="small"
                      type="inner"
                      // style={{ marginBottom: 16, borderRadius: 8 }}
                      // bodyStyle={{ padding: 16 }}
                      className="mb30 card-section custom"
                    >
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Text type="secondary">Property & Location</Text>
                          <div>{item.PropertyAndLocation ? item.PropertyAndLocation : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Owner</Text>
                          <div>{item.Owner ? item.Owner : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Date Acquired</Text>
                          <div>{item.DateAcquired ? _commonService.convertToMMDDYYYY(item.DateAcquired) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Cost</Text>
                          <div>{item.Cost ? `$ ${_commonService.formatNumberWithCommas(item.Cost)}` : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Market Value</Text>
                          <div>{item.MarketValue ? `$ ${_commonService.formatNumberWithCommas(item.MarketValue)}` : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Mortgagor</Text>
                          <div>{item.Mortgagor ? item.Mortgagor : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          <Text type="secondary">Maturity Date</Text>
                          <div>{item.Maturity ? _commonService.convertToMMDDYYYY(item.Maturity) : "N/A"}</div>
                        </Col>
                        <Col span={8}>
                          {canSeeAdjustments ? (
                            <AdjustmentField
                              label="Amount"
                              asSubmittedValue={item.Amount}
                              adjustment={findAdjustment(AdjustmentTableName.ApplicantMortgageDueBeyond, "Amount", item.Id)}
                              canEdit={canEditAdjustments}
                              onSave={(value, reason) => handleSaveAdjustment(AdjustmentScreenModule.BalanceSheetLiability, AdjustmentTableName.ApplicantMortgageDueBeyond, "Amount", item.Id, value, reason)}
                              onViewHistory={() => handleViewHistory(AdjustmentTableName.ApplicantMortgageDueBeyond, "Amount", item.Id)}
                            />
                          ) : (
                            <>
                              <Text type="secondary">Amount</Text>
                              <div>{item.Amount ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}` : "N/A"}</div>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Card>
                  ))
                }
              </CollapsePanel>
            </Collapse>
            {renderStaticAdjustmentRow("Unpaid Income Taxes", financialStatementDataDetails?.UnpaidIncomeTaxesTotal, "UnpaidIncomeTaxesTotal", AdjustmentScreenModule.BalanceSheetLiability)}
            {renderStaticAdjustmentRow("Long Term Notes Payable", financialStatementDataDetails?.Long_Term_Notes_Payable, "Long_Term_Notes_Payable", AdjustmentScreenModule.BalanceSheetLiability)}
            {renderStaticAdjustmentRow("Deferred Tax Liabilities", financialStatementDataDetails?.Deferred_Tax_Liabilities, "Deferred_Tax_Liabilities", AdjustmentScreenModule.BalanceSheetLiability)}
            {renderStaticAdjustmentRow("Other Long Term Liabilities", financialStatementDataDetails?.Other_Long_Term_Liabilities, "Other_Long_Term_Liabilities", AdjustmentScreenModule.BalanceSheetLiability)}
            {renderStaticAdjustmentRow("Margin Accounts", financialStatementDataDetails?.MarginAccountTotal, "MarginAccountTotal", AdjustmentScreenModule.BalanceSheetLiability)}
            {renderStaticAdjustmentRow("Other Liabilities", financialStatementDataDetails?.OtherLiabilitiesTotal, "OtherLiabilitiesTotal", AdjustmentScreenModule.BalanceSheetLiability)}
            {/* <div class="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
          <div class="ant-col">
            <span class="ant-typography"><strong>Total Liabilities</strong></span>
          </div>
          <div class="ant-col">
            <span class="ant-typography"><strong>{financialStatementDataDetails.LiabilitiesTotal}</strong></span>
          </div>
        </div> */}
            <div class="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
              <div class="ant-col">
                <span class="ant-typography"><strong>Net Worth</strong></span>
              </div>
              <div class="ant-col">
                {canSeeAdjustments ? (
                  // Read-only: no onSave/onViewHistory, so no edit/history icon (Net Worth is
                  // purely derived -- Assets Total minus Liabilities Total, never directly
                  // adjustable), but the "Adjusted" block appears automatically once
                  // RecalculateNetWorthTotal has recorded one.
                  <AdjustmentField
                    label=""
                    asSubmittedValue={financialStatementDataDetails?.NetWorthTotal}
                    adjustment={findAdjustment(AdjustmentTableName.Applicant, "NetWorthTotal")}
                    canEdit={false}
                  />
                ) : (
                  <span className="ant-typography"><strong>{financialStatementDataDetails.NetWorthTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.NetWorthTotal)}` : "N/A"}</strong></span>
                )}
              </div>
            </div>

            <CommentSection CommentSectionName="balancesheetliability" applicationstatusid={applicationstatusid} applicantDetails={applicantDetails} ApplicationObjId={ApplicationObjId} />
          </div>
        </Card>
      </div>
      <BalanceSheetQuestionnaireDashboard isUsedInBanker={true} applicationstatusid={applicationstatusid} applicantDetails={applicantDetails} ApplicationObjId={ApplicationObjId} />

    </Spin>
  )
}
export default FinancialStatementTab;